import {
  CART_TOP_REF_UPDATE,
  CART_BOTTOM_REF_UPDATE,
  CART_TYPE_UPDATE
} from "../actions/cartPosition";

const initialState = {
  cartTopRef: null,
  cartBottomRef: null,
  cart: "Top"
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CART_TOP_REF_UPDATE:
      return {
        ...state,
        cartTopRef: action.payload
      };
    case CART_BOTTOM_REF_UPDATE:
      return {
        ...state,
        cartBottomRef: action.payload
      };
    case CART_TYPE_UPDATE:
      return {
        ...state,
        cart: action.payload
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/cartPositionReducer.js